import * as React from 'react';
import { Question } from '../types/questionnaire.types';
import { isQuestionAnswered } from '../utils/questionValidation';

interface UseQuestionNavigationProps {
  questions: Question[];
  responses: Record<string, string>;
}

export const useQuestionNavigation = ({
  questions,
  responses,
}: UseQuestionNavigationProps) => {
  const [currentQuestion, setCurrentQuestion] = React.useState(0);

  const handleNext = React.useCallback(() => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    }
  }, [currentQuestion, questions.length]);

  const handleBack = React.useCallback(() => {
    if (currentQuestion > 0) {
      setCurrentQuestion((prev) => prev - 1);
    }
  }, [currentQuestion]);

  const goToQuestion = React.useCallback((index: number) => {
    setCurrentQuestion(index);
  }, []);

  const canGoBack = currentQuestion > 0;
  const canGoNext = currentQuestion < questions.length - 1;

  const currentQuestionData = questions[currentQuestion];
  const isCurrentAnswered = isQuestionAnswered(
    currentQuestionData,
    responses[currentQuestionData.id]
  );

  const canProceed = !currentQuestionData.required || isCurrentAnswered;

  return {
    currentQuestion,
    setCurrentQuestion,
    handleNext,
    handleBack,
    goToQuestion,
    canGoBack,
    canGoNext,
    canProceed,
    isCurrentAnswered,
  };
};
